import { Skeleton } from '@mui/material';

const BoatInfoSkeleton = () => {
  return (
    <div className="pt-6">
      <Skeleton variant="text" width="60%" height={32} />

      <div className="pt-4 flex items-center content-center gap-2 self-stretch">
        <div className="flex flex-wrap items-center gap-2">
          {[1, 2, 3].map(item => (
            <Skeleton
              key={item}
              variant="rectangular"
              width={80}
              height={32}
              className="rounded-full"
            />
          ))}
        </div>
      </div>

      <div className="mt-12 flex flex-col items-start gap-2 flex-shrink-0 relative md:hidden">
        <Skeleton
          variant="rectangular"
          width="100%"
          height={256}
          className="rounded-2xl"
        />
      </div>
      <div className="gap-2 w-full mt-12 hidden md:grid grid-cols-2">
        <div className="w-full">
          <Skeleton
            variant="rectangular"
            width="100%"
            height={480}
            className="rounded-l-3xl"
          />
        </div>
        <div className="grid grid-cols-2 gap-2 relative">
          {[1, 2, 3, 4].map((item, index) => (
            <Skeleton
              key={item}
              variant="rectangular"
              width="100%"
              height={240}
              className={`${index === 1 ? 'rounded-tr-3xl' : ''} ${
                index === 3 ? 'rounded-br-3xl' : ''
              }`}
            />
          ))}
          <Skeleton
            variant="rectangular"
            width={160}
            height={48}
            className="absolute bottom-6 right-6 rounded-md"
          />
        </div>
      </div>
    </div>
  );
};

export default BoatInfoSkeleton;
